import { useMemo, useState } from 'react'

import { SubscribedOnDataDto } from '@api'
import { format } from 'date-fns/format'

import type { ListUser } from '@/modules/chatting/types'

import { ExpandableDetails } from './ExpandableDetails'
import { SpendingsHistory } from './SpendingsHistory'

interface Props {
  subscription: SubscribedOnDataDto
  userId: ListUser['id']
}

export const SubscriptionDetails = ({ subscription, userId }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const details = useMemo(() => {
    return [
      {
        label: 'Previous subscription',
        value: subscription.subscribePrice
          ? String(subscription.subscribePrice)
          : 'Free',
        hideable: true,
      },
      {
        label: 'Started',
        value: subscription.subscribeAt
          ? format(new Date(subscription.subscribeAt), 'MMM dd, yyyy')
          : '',
        hideable: true,
      },
      {
        label: 'Total duration',
        value: subscription.duration || '',
        hideable: false,
      },
      {
        label: 'Expired',
        value: subscription.expiredAt
          ? format(new Date(subscription.expiredAt), 'MMM dd, yyyy')
          : '',
        hideable: false,
      },
      {
        label: 'Reason',
        value: subscription.unsubscribeReason || '',
        className:
          subscription.unsubscribeReason === 'No reason given'
            ? 'text-secondary-300'
            : '',
        hideable: true,
      },
    ]
  }, [subscription])

  return (
    <>
      {isExpanded && (
        <div className="mb-6">
          <SpendingsHistory userId={userId} />
        </div>
      )}
      <ExpandableDetails
        details={details}
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
      />
    </>
  )
}
